
import { Permission } from '@/types/common';

export const ROLE_PERMISSIONS: Record<string, Permission[]> = {
  admin: [
    'candidates.read',
    'candidates.write',
    'candidates.delete',
    'assessments.read',
    'assessments.write',
    'colleges.read',
    'colleges.write',
    'job_positions.read',
    'job_positions.write',
    'questions.read',
    'questions.write',
    'admin.all',
  ],
  hr: [
    'candidates.read',
    'candidates.write',
    'assessments.read',
    'assessments.write',
    'colleges.read',
    'colleges.write',
    'job_positions.read',
    'job_positions.write',
    'questions.read',
  ],
  panelist: [
    'candidates.read',
    'assessments.read',
    'assessments.write',
  ],
};

export const hasPermission = (userRole: string, requiredPermission: Permission): boolean => {
  const rolePermissions = ROLE_PERMISSIONS[userRole] || [];
  return rolePermissions.includes(requiredPermission) || rolePermissions.includes('admin.all');
};

export const hasAnyPermission = (userRole: string, requiredPermissions: Permission[]): boolean => {
  return requiredPermissions.some(permission => hasPermission(userRole, permission));
};

export const hasAllPermissions = (userRole: string, requiredPermissions: Permission[]): boolean => {
  return requiredPermissions.every(permission => hasPermission(userRole, permission));
};
